import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ref, onValue } from 'firebase/database';
import { database } from '../../utils/firebase';

const RosterReport = () => {
    const { leagueId, activeDate, print, header } = useParams();
    const [players, setPlayers] = useState([]);
    const [leagueSettings, setLeagueSettings] = useState({});
    const [leagueData, setLeagueData] = useState({});

    useEffect(() => {
        const leagueRef = ref(database, `leagues/${leagueId}`);
        onValue(leagueRef, (snapshot) => {
            const data = snapshot.val();
            if (data) {
                setLeagueData(data);
                setLeagueSettings(data.settings);
            } else {
                console.error('No settings found for the given leagueId.');
            }
            if (print === 'true') {
                setTimeout(() => {
                    window.print();
                }, 100); // 2 seconds delay
            }
        }, (error) => {
            console.error('Error fetching league settings from Firebase:', error);
        });
    }, [leagueId]);

    useEffect(() => {
        const playersRef = ref(database, `leagues/${leagueId}/players`);
        onValue(playersRef, (snapshot) => {
            const data = snapshot.val();
            console.log('Fetched players data:', data);
            if (data) {
                const activePlayers = Object.values(data).filter(player => {
                    const joinDate = player.startDate;
                    const leaveDate = player.endDate || Infinity;
                    console.log('Player:', player.name, 'Join Date:', joinDate, 'Leave Date:', leaveDate);
                    return joinDate <= parseInt(activeDate) * 1000 && leaveDate >= parseInt(activeDate) * 1000;
                });
                console.log('Active players:', activePlayers);
                setPlayers(activePlayers);
            } else {
                console.log('No players found for the given leagueId.');
            }
        }, (error) => {
            console.error('Error fetching players from Firebase:', error);
        });
    }, [leagueId, activeDate]);

    const formatDate = (timestamp) => {
        const options = { month: 'short', day: 'numeric', year: 'numeric' };
        return new Date(timestamp).toLocaleDateString(leagueSettings.language, options);
    };

    return (
        <div style={{backgroundColor: '#ffffff'}}>
            <div className={'modern-report report-container'}>
                <div className="modern-report-container">
                    {header === 'true' && (
                        <div className={'modern-report-header'}>
                            <h1>Roster Report</h1>
                            <h3>{leagueData.name}</h3>
                            <h4>{leagueData.parentGroup}</h4>
                            <h4>{formatDate(parseInt(activeDate) * 1000)}</h4>
                        </div>
                    )}
                    <table>
                        <thead>
                            <tr>
                                <th width="40%">Player Name</th>
                                <th width="30%">Join Date</th>
                                <th width="30%">Leave Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {players.map((player, index) => (
                                <tr key={index}>
                                    <td>{player.name}</td>
                                    <td>{formatDate(player.startDate)}</td>
                                    <td>{player.status === 'active' ? '' : formatDate(player.endDate)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default RosterReport;